<template>
  <div id="app">
    <div class="mx-auto">
      <Home />
    </div>
  </div>
</template>

<script>
import Home from "./components/Home.vue";

export default {
  name: "App",

  components: {
    Home,
  },
};
</script>
